import script from "./TextAreaTemplate.vue?vue&type=script&setup=true&lang=ts"
export * from "./TextAreaTemplate.vue?vue&type=script&setup=true&lang=ts"

import "./TextAreaTemplate.vue?vue&type=style&index=0&id=ad867776&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src057020910/src/SAAS-mobile-application/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ad867776"]])

export default __exports__